import { useEffect, useState } from "react";
import styled from "styled-components";

import { ChooseChat } from "../screens/ChooseChat";
import { GlobalBoard } from "../screens/GlobalBoard";
import { showBackButtonWith } from "../telegram/sdk";

// Shown when the app is launched from a DM (no chat context): a two-view shell
// over the chat picker and the global leaderboard. No routed Shell/TabBar yet —
// there's no chat to navigate until the user picks one.
const Shell = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
`;

export function NoChatContext({ onSelectChat }: { onSelectChat: (chatId: number) => void }) {
  const [view, setView] = useState<"chats" | "board">("chats");

  // On the board, wire the Telegram BackButton to return to the picker (the
  // GlobalBoard also has an on-screen "choose a chat" CTA for browsers).
  useEffect(() => {
    if (view !== "board") return;
    return showBackButtonWith(() => setView("chats"));
  }, [view]);

  return (
    <Shell>
      {view === "chats" ? (
        <ChooseChat onSelectChat={onSelectChat} onViewBoard={() => setView("board")} />
      ) : (
        <GlobalBoard onChooseChat={() => setView("chats")} />
      )}
    </Shell>
  );
}
